document.addEventListener("DOMContentLoaded", function () {
  const quantityInput = document.querySelector('input[name="quantity"]');
  if (!quantityInput) return;
  const decreaseButton = document.querySelector(".quantity-btn.decrease");
  const increaseButton = document.querySelector(".quantity-btn.increase");

  decreaseButton.addEventListener("click", function () {
    changeQuantity(-1);
  });

  increaseButton.addEventListener("click", function () {
    changeQuantity(1);
  });

  function changeQuantity(amount) {
    let currentValue = parseInt(quantityInput.value);
    let newValue = currentValue + amount;

    if (newValue < parseInt(quantityInput.min)) {
      newValue = parseInt(quantityInput.min);
    }

    quantityInput.value = newValue;
  }
});

// WF Popup
document.addEventListener('DOMContentLoaded', function () {
    const openPopupBtn = document.getElementById('wfOpenPopup');
    const popup = document.getElementById('wfPopup');
    const closePopupBtn = document.getElementById('wfClosePopup');
  
    // Open popup on button click
    openPopupBtn.addEventListener('click', function () {
      popup.style.display = 'block';
    });
  
    // Close popup on close button click
    closePopupBtn.addEventListener('click', function () {
      popup.style.display = 'none';
    });
  
    // Close popup when clicking outside the popup content
    window.addEventListener('click', function (event) {
      if (event.target === popup) {
        popup.style.display = 'none';
      }
    });
  });